export class Ticket {
    Id: number;
    WarehouseCode: string;
    OwnerCode: string;
    ETADate: Date;
    ETADateString: string;
    BookingNo: string;
    BookingType: string;
    VehicleType: string;
    ContainerNo: string;
    ContainerSize: string;
    SealNo: string;
    Transporter: string;
    LastDate: Date;
    LastDateString: Date;
    SupplierName: string;
    TruckSize: string;
    TimeSlot: string;
    Status: number;
    StorageType: string;
    VehicleNo: string;
    BayNo: string;
    ArrivedDate: Date;
    FinishedDate: Date;
    TruckOutDate: Date;
    CancelledDate: Date;
    EmailAddress: string;
    TruckNo: string;
}



// WEBPACK FOOTER //
// ./src/app/data/models/transaction/op/outbound/ticket/ticket.ts